import { FormControlLabel, TextField } from '@mui/material';

import styled from 'styled-components';
import { Typography } from "@mui/material";
import { useColors } from "../../Context/ColorsContext"
import { MediaQuerys } from '../../styles/GlobalStyle';

const { mobile, tablet, desktop, desktoplarge } = MediaQuerys;

// const tabletStartWidth = 768;
// const mobile = `@media (max-width: ${tabletStartWidth}px)`


export const Text = styled(Typography)(() => {
    const { colors } = useColors();
    return {
        color: colors.red,
        fontSize: 16,
        fontWeight: 'bold',
        margin: 0,
        padding: 0,
    }
})

export const TextSwitch = styled('span')((props) => {
    const { colors } = useColors();
    return {
        fontSize: '11px',
        fontWeight: 600,
        color: colors.white,
        backgroundColor: `${props.enabled ? colors.green : colors.red}`,
        alignItems: 'center',
        textAlign: 'center',
        borderRadius: '6px',
        padding: '4px',
    }
})


export const FormControlSwitch = styled(FormControlLabel)(() => {
    return {
      '& .MuiFormControlLabel-label': {
        fontSize: '11px !important',
        color: '#7b7c7b',
        marginLeft: '8px',
      }
    }
})

export const Container = styled('div')(() => {
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    }
})

export const ContainerGroupOne = styled('div')(({ isDown }) => {
    return {
        marginTop: isDown && '16px',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
    }
})

export const ContainerGroupTwo = styled('div')(() => {
    return {
        marginTop: '16px',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        gap: '16px',
        justifyContent: 'space-between',
        alignItems: 'center',
    }
})

export const CustomContainer = styled('div')(() => {
    return {
        width: '120px',
        height: '50px',
    }
})


export const ContainerGroupPar = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'row',
    }
})

export const CustomTextField = styled(TextField)(() => {
    return {
        width: '100%',
        height: '100%',
        scrollbarWidth: 'thin', // Ajusta el ancho del scroll (solo Firefox)
            '&::-webkit-scrollbar': {
            // Estilos del scroll horizontal (WebKit)
            width: '0.85rem', // Ajusta el ancho del scroll
        },
        [mobile]: {
            '& .MuiInputBase-input': {
                fontSize: '0.85rem'
            }
        },
        [desktop]: {
            '& .MuiInputBase-input': {
                fontSize: '0.85rem'
            }
        }

    }
})